export default {
  alert: state => state.alert,
};
